<template>
  <v-app>
    <v-container fluid>
      <logo/>
      <Menu class="menu"></Menu>
      <v-content class="cont">
        <router-view></router-view>
      </v-content>
      <Footer></Footer>
    </v-container>
  </v-app>
</template>

<script>
import Logo from "./components/Logo";
import Menu from "./components/Menu";
import Footer from "./components/Footer";

export default {
  name: "App",
  components: {
    Logo,
    Menu,
    Footer
  },
  data() {
    return {};
  }
};
</script>
<style>
.cont {
  margin-top: 25px;
  margin-bottom: 25px;
}
</style>
